import React, { useLayoutEffect, useState } from 'react'
import { Button } from 'reactstrap'
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';
import Immutable from 'immutable';
import Modal from '../../../../common/modal/Modal'
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { PUT } from '../../../../../config/permissions';
import EditCustomerUpdateHistoryForm from './EditCustomerUpdateHistoryForm';
import { clearCustomerUpdateHistory, getCustomerUpdateHistory, putCustomerUpdateHistory } from '../../../../../actions';
import Loader from '../../../../common/Loader';
import { GENDERS } from '../../../../../config/constants';
import { tzNormalizeDate } from '../../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../../config/locale';
import { generatePutCustomerUpdateHistoryEndpoint } from '../../../../../config/endpoints';

const CustomerUpdateHistoryChangeButton = ({ ticketId, dispatchGetCustomerUpdateHistory, dispatchClearCustomerUpdateHistory, loading, customerUpdateHistory, dispatchPutCustomerUpdateHistory
  , availableCustomerUpdateHistory, disabled
}) => {
  const [showModal, setShowModal] = useState(false);

  useLayoutEffect(() => () => {
    dispatchClearCustomerUpdateHistory();
  }, []);

  const handleSubmit = (formValues) => {

    const { gender, dateOfBirth, firstName, lastName, email, mobilePhone } = formValues;

    const newFormValues = {
      id: customerUpdateHistory.toJS().id,
      gender: gender ? gender.value : null,
      dob: dateOfBirth ?
        tzNormalizeDate({
          date: dateOfBirth, format: INT_DATE_FORMAT
        })
        : null,
      firstName,
      lastName,
      email,
      mobilePhone
    }

    dispatchPutCustomerUpdateHistory({ ticketId, payload: newFormValues });
  }

  const handleCloseModal = () => {
    setShowModal(false)
    dispatchClearCustomerUpdateHistory();
  };

  const handleShowModal = async () => {
    if (!availableCustomerUpdateHistory) {
      toastr.warning("Atención", "No se puede cambiar datos del pasajero porque este boleto fue creado en una versión anterior o no fue generado desde la web.");
      return
    }
    setShowModal(true);
    dispatchGetCustomerUpdateHistory(ticketId);
  }

  const generateIntialValues = (customer) => {
    const findGender = GENDERS.find(g => g.value === customer.gender);
    return {
      ...customer,
      gender: findGender,
      dateOfBirth: customer.dob ?
        tzNormalizeDate({
          date: customer.dob, format: INT_DATE_FORMAT, addTime: {
            amount: 5,
            unit: 'h',
          }
        })
        : null,
    }
  }

  let content = null;

  if (loading) content = <Loader />;
  else if (!loading && !customerUpdateHistory.isEmpty()) {
    content = (
      <EditCustomerUpdateHistoryForm
        initialValues={generateIntialValues(customerUpdateHistory.toJS())}
        onSubmit={handleSubmit}
        onCancel={handleCloseModal}
      />);
  }

  return (
    <>
      <Button
        color="light"
        className="border"
        onClick={handleShowModal}
        disabled={loading || disabled}
      >
        <i className={`fa fa-${loading ? 'spinner fa-spin' : 'user'}`} />{' '}
        Cambiar Datos del Pasajero
      </Button>
      <Modal show={showModal} title="Cambiar Datos del Pasajero" body={content} />
    </>
  )
}

CustomerUpdateHistoryChangeButton.propTypes = {
  ticketId: PropTypes.number.isRequired,
  dispatchGetCustomerUpdateHistory: PropTypes.func.isRequired,
  dispatchClearCustomerUpdateHistory: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  customerUpdateHistory: PropTypes.instanceOf(Immutable.Map).isRequired,
  dispatchPutCustomerUpdateHistory: PropTypes.func.isRequired,
  availableCustomerUpdateHistory: PropTypes.bool,
  disabled: PropTypes.bool
}

CustomerUpdateHistoryChangeButton.defaultProps = {
  loading: false,
  availableCustomerUpdateHistory: false,
  disabled: false
}

const mapStateToProps = ({ ReservationUnit }) => ({
  loading: ReservationUnit.Ticket.getIn([
    'current',
    'loading',
  ]),
  customerUpdateHistory: ReservationUnit.Ticket.getIn([
    'current',
    'customerUpdateHistory',
  ]),
})

const mapDispatchToProps = {
  dispatchGetCustomerUpdateHistory: getCustomerUpdateHistory,
  dispatchClearCustomerUpdateHistory: clearCustomerUpdateHistory,
  dispatchPutCustomerUpdateHistory: putCustomerUpdateHistory,
}

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomerUpdateHistoryChangeButton);

export default withEndpointAuthorization({
  url: generatePutCustomerUpdateHistoryEndpoint(0),
  permissionType: PUT,
})(connectedComponent);
